import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Footer = () => {
  return (
    <React.Fragment>
      <footer className='footer'>
        <Container fluid={true}>
          <Row>
            <Col md={6}>
              {new Date().getFullYear()} © OISP |{' '}
              <span
                className='tw-cursor-pointer'
                onClick={() => {
                  window.open('https://oisp-privacy-policy.web.app', '_blank');
                }}
              >
                POLICY
              </span>
            </Col>
            <Col md={6}>
              <div className='text-sm-end d-none d-sm-block'>Developed by Fessior Community</div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
